import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { first } from "rxjs/operators";
import { ApiService } from "src/app/api.service";
import { AssistHdr } from "src/app/shared/models/AssistHdr";
import { GuideModel } from "src/app/shared/models/guide-model";
import { AuthenticationService } from "src/app/_services";
import { TovpilLanguageService } from "src/app/utils/tovpil-language.service";
import { UserPreferencesService } from "src/app/utils/user-preferences.service";
import { CookieTovpil } from "src/app/shared/models/CookieTovpil";

@Component({
  selector: "app-guidelines-assist",
  templateUrl: "./guidelines-assist.component.html",
  styleUrls: ["./guidelines-assist.component.scss"],
  providers: [MessageService, ConfirmationService],
})
export class GuidelinesAssistComponent implements OnInit {
  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT */
  items: AssistHdr[];
  token: string;
  guide: GuideModel;
  device: string;

  /**
   * The constructor initializes various services and properties, retrieves query parameters, and
   * performs authentication based on user preferences.
   * @param {ApiService} apiService - The `apiService` parameter in the constructor is likely a service
   * that handles API calls in your Angular application. It is injected as a private dependency,
   * meaning it is accessible only within the class where it is declared. This service is commonly used
   * to interact with backend APIs to fetch or send data.
   * @param {DatePipe} datepipe - The `DatePipe` is a built-in Angular pipe that is used for formatting
   * dates in templates. It provides various date formats and options for displaying dates in a
   * user-friendly way. You can use it to format dates in your Angular application by passing a date
   * value and a format string to the pipe in
   * @param {ActivatedRoute} route - The `route` parameter in the constructor is of type
   * `ActivatedRoute`, which is a service provided by Angular that contains information about a route
   * associated with a component loaded in an outlet. It can be used to access route parameters, query
   * parameters, and other information related to the current route.
   * @param {Router} router - The `router` parameter in the constructor is an instance of the Angular
   * Router service. It is used for programmatic navigation in Angular applications, allowing you to
   * navigate to different views or components based on user actions or application logic. The `router`
   * parameter in your constructor is injected so that you can use
   * @param {AuthenticationService} authenticationService - The `authenticationService` parameter in
   * the constructor is a service that handles authentication-related functionalities in the
   * application. It is used for tasks such as user login, logout, authentication checks, and managing
   * user sessions. This service likely interacts with the backend to authenticate users and handle
   * access control within the application.
   * @param {TovpilLanguageService} translationService - The `translationService` parameter in the
   * constructor is an instance of `TovpilLanguageService`. It is used for handling language
   * translation within the application. This service likely provides methods for translating text or
   * content into different languages based on the user's preferences or the application's settings.
   * @param {UserPreferencesService} userPreferencesService - The `userPreferencesService` parameter in
   * the constructor is a service that likely handles user preferences and settings within the
   * application. It is used to store and retrieve user-specific configurations, such as language
   * preferences, theme settings, or any other user-related data that needs to persist across sessions.
   * This service allows the
   */
  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private translationService: TovpilLanguageService,
    private userPreferencesService: UserPreferencesService
  ) {
    this.initConfigs();
    this.route.queryParams.subscribe((params) => {
      this.token = params.token;
      this.device = params.device;
    });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const securitySelected = this.globalUserPreferences;
  }

  /**
   * The function initializes form groups for configuration and data, and updates the configuration form
   * with query parameters from the route.
   */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
    console.debug(
      "guideLinesAssist - USER PREFERENCES: " +
      JSON.stringify(this.globalUserPreferences, null, 2)
    );
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            // this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        (error) => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        }
      );
  }

  /**
   * The ngOnInit function calls the getSecurity method when the component is initialized.
   */
  ngOnInit(): void {
    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      } else {
        this.getSecurity();
      }
    } else {
      this.getSecurity();
    }
  }

  /**
   * The function `getSecurity` asynchronously retrieves security data using an API service, then
   * proceeds to fetch translated labels, a guide, and an item list if the security data is
   * successfully obtained.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (securityControl === null || Object.keys(securityControl).length === 0) {

      const tokenProfile = this.globalUserPreferences?.tokenProfile || this.token;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences.preferences = data;
    }

    await this.getTranslatedLabels();
    await this.getGuide();
    await this.getItemList();
  }

  /**
   * The function `getTranslatedLabels` asynchronously retrieves translated labels based on user
   * preferences and handles any errors that occur.
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();

      // await this.getLanguages();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
  }

  /**
   * The function `getGuide` asynchronously retrieves guide data based on the user's preferences using
   * an API service in TypeScript.
   */
  async getGuide() {
    try {
      const guideId = this.globalUserPreferences.preferences.guideId || null;
      if (guideId != null) {
        const data = await this.apiService.getGuideById({ guideId: guideId });
        this.guide = data;
      }
    } catch (e) {
      console.error("getGuideError");
    }
  }

  /**
   * The `getItemList` function asynchronously retrieves a list of items based on the user's language
   * preference.
   */
  async getItemList() {
    try {
      const language = this.globalUserPreferences.preferences.language;
      const data = await this.apiService.getAssistHdrByLanguage({
        language: language,
      });
      this.items = data;
      this.blocked = false;
    } catch (e) {
      console.error("getItemListError");
    }
  }

  /**
   * The `selectRecord` function navigates to a specific route with query parameters in a TypeScript
   * application.
   * @param {string} selItemId - The `selItemId` parameter is a string that represents the selected
   * item ID which will be used to navigate to a specific route in the application.
   */
  selectRecord(selItemId: string) {
    this.router.navigate(["commons/guideLinesAssistDt1"], {
      queryParams: { itemId: selItemId, token: this.token },
    });
  }

  /**
   * The `goBack` function closes the current window.
   */
  goBack() {
    window.close();
  }
}
